<template>
  <div>
    <NavBar />
    <NewStaticRoute @created="getStaticRoutes()" />
    <ViewStaticRoute
      :static_route_id="static_route_id"
      @updated="getStaticRoutes()"
    />
    <b-overlay :show="loading" opacity="0.99">
      <b-container>
        <v-card>
          <v-card-title>
            <b-row align-v="center">
              <b-col cols="auto">
                <v-btn
                  class="v-primary"
                  @click="$bvModal.show('new_static_route')"
                >
                  <span class="fa fa-plus mr-1"></span> Novo
                </v-btn>
              </b-col>
              <b-col cols="auto"> Rotas estáticas </b-col>
              <b-col>
                <v-text-field
                  class="p-0 m-0"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                />
              </b-col>
            </b-row>
          </v-card-title>
          <v-card-text>
            <ErrorsMessages :errors="errors" />
            <b-row>
              <b-col>
                <v-data-table
                  dense
                  :headers="headers"
                  :items="static_routes"
                  :search="search"
                  :footer-props="{
                    'items-per-page-options': [25, 75, 100],
                    'items-per-page-text': 'Mostrar',
                  }"
                  @click:row="openViewModal"
                />
              </b-col>
            </b-row>
          </v-card-text>
        </v-card>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NewStaticRoute from "../templates/static-routes/NewStaticRoute";
import ViewStaticRoute from "../templates/static-routes/ViewStaticRoute";

import api from "../services/api";

import { adminData } from "../lib/functions";

export default {
  name: "StaticRoutes",
  components: {
    NavBar,
    ErrorsMessages,
    NewStaticRoute,
    ViewStaticRoute,
  },
  data() {
    return {
      permissions: {},
      errors: [],

      loading: false,

      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Rota", value: "url" },
        { text: "Versão", value: "version" },
      ],
      static_routes: [],
      static_route_id: "",
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.getStaticRoutes();
  },
  methods: {
    async openViewModal(item) {
      this.static_route_id = item.id;
      this.$bvModal.show("view_static_route");
    },

    async getStaticRoutes() {
      try {
        this.loading = true;

        let response = await api.get("/admin/rest-home/static-routes");
        let { error, errors, static_routes } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.static_routes = static_routes;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>